import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

@Directive({
  selector: '[businessValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: BusinessValidatorDirective, multi: true }]
})
export class BusinessValidatorDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } {
    return businessValidator(control);
  }
}

export function businessValidator(control: AbstractControl) {
  let choice = control.get('businessChoice').value;
  let other = control.get('other').value;

  if (choice == 'Select a Business') {
    return { 'required': true };
  } else if (choice == 'Other' && other == '') {
    return { 'otherRequired': true };
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/directives/business-validator.directive.ts